<template>
  <v-alert
    v-if="isNonAscii"
    class="mt-1"
    type="warning"
  >
    Non-ASCII characters are detected in the above JSON. If this is not intentional, make sure to check the text for homoglyphs.
  </v-alert>
</template>

<script>
export default {
  props: {
    sourceObject: Object,
  },

  computed: {
    isNonAscii() {
      const rawJson = JSON.stringify(this.sourceObject)

      let hasNonAscii = false

      for (let i = 0; i < rawJson?.length; i++) {
        if (rawJson.charCodeAt(i) > 127) {
          hasNonAscii = true
          break
        }
      }

      return hasNonAscii
    },
  }
}
</script>
